/* tslint:disable */

/**
 */
export class LocationAxisParams {
    AXIS_AXE1_X?: number;
    ID_STUDY_EQUIPMENTS?: number;
    POINT_TOP_X?: number;
    POINT_TOP_Y?: number;
    POINT_TOP_Z?: number;
    POINT_INT_X?: number;
    POINT_INT_Y?: number;
    POINT_INT_Z?: number;
    POINT_BOT_X?: number;
    POINT_BOT_Y?: number;
    POINT_BOT_Z?: number;
    NB_STEPS?: number;
    AXIS_AXE1_Y?: number;
    AXIS_AXE1_Z?: number;
    AXIS_AXE2_X?: number;
    AXIS_AXE2_Y?: number;
    AXIS_AXE2_Z?: number;
    AXIS_AXE3_X?: number;
    AXIS_AXE3_Y?: number;
    AXIS_AXE3_Z?: number;
    PLAN_X?: number;
    PLAN_Y?: number;
    PLAN_Z?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/location-axis-params.ts